import { Btn } from 'components/Btn'
import { Circle } from 'components/Circle'
import { Icon } from 'components/Icon'
import { Shield } from 'components/Shield'
import { CandidateSkillIntersect, CandidateSkillWithScore } from 'types'
import { Text } from 'components/Text'
import { calcScoreForDisplay, isVettedSkill, skillLevelsWithInfo } from 'utils'
import React from 'react'
import styled, { css } from 'styled-components'
import { OnNavToCandidateSkill, OnSelectCandidateSkill } from './'

export const skillItemStyles = css`
	transition: all ${props => props.theme.times.tranS};

	.checkbox {
		border: solid 1px ${props => props.theme.colors.midNeutral.val};
		background: ${props => props.theme.colors.white.val};
		margin-right: 1em;
		border-radius: 50%;
		height: 32.5px;
		width: 32.5px;
		display: flex;
		align-items: center;
		justify-content: center;

		.icon {
			opacity: 0;
		}
	}

	&._is-select {
		border-bottom: 1px solid transparent;
	}

	&.__selected {
		border-bottom: 1px solid ${props => props.theme.colors.white.val};

		.checkbox {
			.icon {
				opacity: 1;
			}
		}
	}

	&.__last-selected,
	&:hover {
		background: ${props => props.theme.colors.primary.opacity(5).val};
	}

	& > button {
		width: 100%;
		text-align: left;
		display: flex;
		align-items: center;
		padding: 0.5em ${props => props.theme.sizes.gutter.mobile.val};
		border-bottom: 1px solid ${props => props.theme.colors.lightNeutral.val};
		& > .txt {
			margin: 0;
			padding-right: 0.5em;
			font-size: 1.3rem;
		}
	}
	.score-vetting-status {
		display: inline-flex;
		margin-left: auto;
		align-items: center;
		.circle {
			margin-left: 0.5em;
		}
	}
	.shield {
		display: flex;
		align-items: center;
		justify-content: center;
		.icon {
			height: 42px;
			max-height: 42px;
		}
	}

	&.__private {
		&.__vetted {
			& > button {
				& > .txt {
					opacity: 0.5;
				}
			}
		}
	}
`

const CandidateSkillListItemView = styled.div`
	${skillItemStyles}
`

export type CandidateSkillListItemOptions = {
	showLevel?: boolean
}

type CandidateSkillListItemProps = CandidateSkillListItemOptions & {
	skill: CandidateSkillIntersect
	onSelect?: OnSelectCandidateSkill
	onNav?: OnNavToCandidateSkill
	isSelected?: boolean
	isLastSelected?: boolean
}
export const CandidateSkillListItem = ({
	isSelected,
	onSelect,
	onNav,
	skill,
	isLastSelected,
	...props
}: CandidateSkillListItemProps) => {
	const { skillName, currentSkillLevelId, candidateSkillId, visible, ...skillWithScore } = skill
	const { score, overallVetting } = skillWithScore as CandidateSkillWithScore

	const { color } = skillLevelsWithInfo.find(({ levelId }) => levelId === currentSkillLevelId) || {}
	const isVetted = isVettedSkill(skillWithScore as CandidateSkillWithScore)

	return (
		<CandidateSkillListItemView
			className={`skill${onSelect ? ' _is-select' : ''}${isSelected ? ' __selected' : ''}${
				isLastSelected ? ' __last-selected' : ''
			}${isVetted ? ' __vetted' : ''}${visible ? ' __public' : ' __private'}`}
		>
			<Btn
				{...props}
				onClick={() => {
					if (onNav) onNav(candidateSkillId)
					else if (onSelect) onSelect(skill)
				}}
				disabled={!onNav && !onSelect}
			>
				{onSelect ? (
					<div className={`checkbox`}>
						<Icon type='checkCircle' />
					</div>
				) : null}
				<Text color={isVetted ? color : visible ? 'darkNeutral' : 'midNeutral'}>{skillName}</Text>
				<div className='score-vetting-status'>
					<Shield isSmall value={overallVetting || null} />
					<Circle
						color={color}
						isSolid={overallVetting === 1 && score > 0}
						value={calcScoreForDisplay(score)}
					/>
				</div>
			</Btn>
		</CandidateSkillListItemView>
	)
}
